// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The review card shares the docs/03 chat-feedback surface with AgentChatCard
   and adds the system review controls (Apply/Dismiss) — the sanctioned
   exception family to "no agent action buttons" (docs/08, DEC-035 pattern). */

.c_yQ1hJrmzZg16wZJySr {
  background: var(--curio-surface-muted);
  border: 1px solid var(--curio-border);
  border-radius: 12px;
  padding: 12px 16px;
  margin-top: 8px;
  max-width: 100%;
}

.XaZ0DF3Mq1bQSg64e6rD {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  font-weight: 600;
}
/* The default colour sits in :where() so it has no specificity: the chat panel's
   category tint class on the same element wins regardless of which stylesheet the
   bundler emits first (the dev/142 panel decomposition changed that order and the
   review/result cards lost their tint). */
:where(.XaZ0DF3Mq1bQSg64e6rD) {
  color: var(--curio-text-primary);
}

.XlJ7yaqUzLvfe7CaJAWz {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
  flex: 0 0 auto;
}

.fXxjWqNp9g9kGJnSHcvA {
  font-weight: 400;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--curio-text-meta);
  flex: 0 0 auto;
  white-space: nowrap;
}

.ORmL_YmfCrNOshFxSj8i {
  background: var(--curio-card-bg);
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 8px;
  font-size: 0.8rem;
  color: var(--curio-text-secondary);
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 220px;
  overflow-y: auto;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

.iTw0KtmO9_ZeojNnthZC {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}

.wa77Q9ygBxX1MtJXF8pg {
  border: none;
  border-radius: 8px;
  padding: 6px 16px;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--curio-text-on-dark);
  background: var(--curio-success-text);
  cursor: pointer;
}

.wa77Q9ygBxX1MtJXF8pg:disabled {
  opacity: 0.6;
  cursor: default;
}

.wfO2zuR9VuZRALhw5WxU {
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 0.8rem;
  color: var(--curio-text-secondary);
  background: var(--curio-card-bg);
  cursor: pointer;
}

.wfO2zuR9VuZRALhw5WxU:disabled {
  opacity: 0.6;
  cursor: default;
}

.FhIGkbyO3v_jkEKJErqf {
  margin-top: 10px;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--curio-text-secondary);
}

.GF8NPrU5M3FNo1e2TEpu {
  color: var(--curio-success-text);
}

.Ol2Z74RStwkH6W0_3tQr {
  color: var(--curio-warning-text);
}

.DLGHKA1GUq8QQQflI0vo {
  margin-top: 8px;
  font-size: 0.76rem;
  color: var(--curio-danger-text);
}

/* A package draft's justification for its new node types: the model's
   reasoning, rendered verbatim above the draft's details. */
.lEfUDGL_6wzgv6jMK5Ft {
  margin-top: 8px;
  padding: 8px 10px;
  font-size: 0.78rem;
  line-height: 1.45;
  white-space: pre-wrap;
  background: var(--curio-warning-bg);
  border-left: 3px solid var(--curio-warning-text);
  border-radius: 4px;
  color: var(--curio-warning-text);
}

/* Secondary metadata / effect lines under the preview. */
.GUcTCeHwo2Stw9FmPJ6k {
  margin-top: 6px;
  font-size: 0.74rem;
  color: var(--curio-text-secondary);
}

/* dev/59 (DEC-049.2) — the destructive Removes section: reviewed by name. */
.u3or3OY1hwgL66hrDZ71 {
  margin-top: 8px;
  padding: 8px 10px;
  background: var(--curio-danger-bg);
  border-left: 3px solid var(--curio-danger-text);
  border-radius: 4px;
}

.QLjKHtm5uDcfxgHRXbzZ {
  font-size: 0.76rem;
  font-weight: 700;
  color: var(--curio-danger-strong);
}

.jfrQu3R0XzS_5rj74rts {
  margin: 4px 0 0;
  padding-left: 18px;
  font-size: 0.74rem;
  color: var(--curio-danger-strong);
}

/* dev/67-5 — the per-node plan review rows (Simulation Mode: create). */
.HQl2HrIB8Xls9YVFcw3g {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
}

.Omoie3kvonUE5tcfMlJF {
  border: 1px solid var(--curio-border);
  border-radius: 6px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rDkdKv1L0K35odLTtiMu {
  display: flex;
  align-items: center;
  gap: 8px;
}

.xXZJ_Y2r7O611uokmfPu {
  font-weight: 600;
  font-size: 0.85rem;
}

.glPOeqqK0wte1u0xJlyr {
  color: var(--curio-text-secondary);
  font-size: 0.75rem;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zuPyxMaHxsOqWUJlWv5O {
  color: var(--curio-success-text);
  font-size: 0.78rem;
  font-weight: 600;
}

.S9FK68_Txx1Qm1XZVoX6 {
  color: var(--curio-text-secondary);
  font-size: 0.75rem;
}

/* dev/72: the compact icon-link riding a row's review chip — opens the node
 * agent's chat, where the content review and Solve trace live. */
.bcMOCFRaCMac771vQ8kA {
  margin-left: 5px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid currentColor;
  background: var(--curio-card-bg);
  color: inherit;
  font-size: 9px;
  padding: 0;
  cursor: pointer;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.bcMOCFRaCMac771vQ8kA:hover,
.bcMOCFRaCMac771vQ8kA:focus-visible {
  transform: scale(1.12);
  outline: none;
}

.mWkBauPD23Qc7TBsxpuK {
  width: 100%;
  box-sizing: border-box;
  font: inherit;
  font-size: 0.8rem;
  padding: 6px 8px;
  border: 1px solid var(--curio-border-strong);
  border-radius: 4px;
  resize: vertical;
}

.mWkBauPD23Qc7TBsxpuK:disabled {
  background: var(--curio-surface-muted);
  color: var(--curio-text-secondary);
}

/* dev/67-7 — the validation verdict block. */
.XTniMIjeUOinOVqpaKdq {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.8rem;
}

.dzpV1RYVi1BjoVKmci2T {
  background: var(--curio-success-bg);
  border: 1px solid var(--curio-success-bg);
  color: var(--curio-success-text);
}

.GKH3APA9mpg2y1nfB2ss {
  background: var(--curio-danger-bg);
  border: 1px solid var(--curio-danger-border);
  color: var(--curio-danger-text);
}

.imFApHGhhaxGPmbzbgkU {
  font-weight: 700;
  letter-spacing: 0.04em;
}

.aWp14DI9dgOGuYy5MQGQ {
  flex-basis: 100%;
}

.aWp14DI9dgOGuYy5MQGQ pre {
  margin: 6px 0 0;
  max-height: 160px;
  overflow: auto;
  font-size: 0.72rem;
  white-space: pre-wrap;
}

/* dev/67-8 — the connection review rows (Simulation Mode: connect). */
.DyiCofErvZ8mmAsbmuYN {
  margin-top: 8px;
  border: 1px solid var(--curio-border);
  border-radius: 6px;
  padding: 8px 10px;
}

.BSnuADPIzpGXSFO4cIbw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.82rem;
  margin-bottom: 6px;
}

.Nc2C5DlEQpzLzg_q8ncY {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tTs6pErgFjGhXqFBg0eV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 0.8rem;
}

.tTs6pErgFjGhXqFBg0eV .wa77Q9ygBxX1MtJXF8pg {
  flex: 0 0 auto;
  white-space: nowrap;
}

.r7vavrXRuawOpe202eLg {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.75rem;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}

.T6xa3Dtmp_2GDnUZbpQU {
  color: var(--curio-danger-text);
  font-size: 0.78rem;
  font-weight: 600;
}

/* #662: a scenario the plan saves, in its color, with its nodes by name. */
.xucd8XxWdumB3Hyo64ho {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.8rem;
}

.kQFiptb2EYlHi7nbxMSx {
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  margin-top: 4px;
  border-radius: 3px;
  background: var(--scenario-color);
}

.tDreBcNhIhUGlpiRpMVh {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
}

.LjRRjl8UIFhP2C8JFsZ8 {
  font-weight: 600;
}

/* dev/96: the rich draft sections — native disclosure, calm by default. */
.yGqSRkAPXCYCPMrCEizL {
    margin: 8px 12px 0;
    font-size: var(--curio-font-size-sm);
    font-family: var(--curio-font-family);
    color: var(--curio-text-secondary, var(--curio-text-secondary));
}

.yGqSRkAPXCYCPMrCEizL summary {
    cursor: pointer;
    font-weight: 600;
    color: var(--curio-text-primary);
}

.iHi2YWRXRowBMRMaI91w {
    margin: 4px 0 0;
    padding-left: 18px;
    overflow-wrap: anywhere;
}

.vWJUGFzrD79_khhpzBHv {
    font-style: italic;
}

.K1RHPRmIQ_2eN0mgKR4w {
    color: var(--curio-danger-strong, var(--curio-danger-text));
    font-weight: 600;
}

._1a9SXJXDC1Qol5j8GUcw {
    color: var(--curio-warning-text);
}

._7NYx1mcJw6vrTIDQQWr {
    margin: 8px 12px 0;
    font-size: var(--curio-font-size-sm);
    color: var(--curio-text-secondary, var(--curio-text-secondary));
}

/* dev/114 (DEC-072) — the Source block: how the runtime grounded what the
   proposed code opens or fetches. Neutral surface; the verdict chip states
   its status in text. */
.E70nPb3aZdMoByfViSAQ {
    margin-top: 8px;
    padding: 8px 10px;
    border-radius: 6px;
    background: var(--curio-surface-muted);
    border: 1px solid var(--curio-border);
    font-size: 0.76rem;
}

.Xg2aEOrXrvZZwO0oJiNF {
    font-weight: 700;
    color: var(--curio-text-primary);
}

.CWiiRGEBSQDOaJaBfhYC {
    margin: 4px 0 0;
    padding-left: 18px;
    color: var(--curio-text-secondary);
    overflow-wrap: anywhere;
}

/* dev/115 — the verification attempt trail (collapsed by default). */
.Sd2cXaKhxpkIUCboA_ii {
    margin: 6px 0 0;
    padding-left: 18px;
    font-size: 0.74rem;
}

.iGtqwGX0gbYNWcpOGkQO {
    font-weight: 600;
}

.aEHokL6SePrQF03aw4ei {
    color: var(--curio-text-secondary);
}

.HNPRhqpivrjSYoYhmFIT summary {
    cursor: pointer;
    color: var(--curio-danger-text);
    overflow-wrap: anywhere;
}

.URaiPGZxl2zYYwGP46wX {
    display: block;
    color: var(--curio-text-secondary);
    overflow-wrap: anywhere;
}

.X3shZyRyTw9CDKMoqG_m {
    display: inline-block;
    margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/content/AgentReviewCard.module.css"],"names":[],"mappings":"AAAA;;8EAE8E;;AAE9E;EACE,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;;0CAG0C;AAC1C;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;4DAC4D;AAC5D;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,mCAAmC;EACnC,gDAAgD;EAChD,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,4EAA4E;AAC5E;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC;EAClC,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;iEACiE;AACjE;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;EACd,cAAc;EACd,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,sEAAsE;AACtE;EACE,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;IACI,kBAAkB;IAClB,oCAAoC;IACpC,qCAAqC;IACrC,+DAA+D;AACnE;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2DAA2D;IAC3D,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,+DAA+D;AACnE;;AAEA;;wBAEwB;AACxB;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;IACtC,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA,qEAAqE;AACrE;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB","sourcesContent":["/* The review card shares the docs/03 chat-feedback surface with AgentChatCard\n   and adds the system review controls (Apply/Dismiss) — the sanctioned\n   exception family to \"no agent action buttons\" (docs/08, DEC-035 pattern). */\n\n.card {\n  background: var(--curio-surface-muted);\n  border: 1px solid var(--curio-border);\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin-top: 8px;\n  max-width: 100%;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n/* The default colour sits in :where() so it has no specificity: the chat panel's\n   category tint class on the same element wins regardless of which stylesheet the\n   bundler emits first (the dev/142 panel decomposition changed that order and the\n   review/result cards lost their tint). */\n:where(.header) {\n  color: var(--curio-text-primary);\n}\n\n.accentDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  flex: 0 0 auto;\n}\n\n.kind {\n  font-weight: 400;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--curio-text-meta);\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.preview {\n  background: var(--curio-card-bg);\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  padding: 8px 12px;\n  margin-top: 8px;\n  font-size: 0.8rem;\n  color: var(--curio-text-secondary);\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 220px;\n  overflow-y: auto;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.apply {\n  border: none;\n  border-radius: 8px;\n  padding: 6px 16px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--curio-text-on-dark);\n  background: var(--curio-success-text);\n  cursor: pointer;\n}\n\n.apply:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.dismiss {\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  padding: 6px 14px;\n  font-size: 0.8rem;\n  color: var(--curio-text-secondary);\n  background: var(--curio-card-bg);\n  cursor: pointer;\n}\n\n.dismiss:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.outcome {\n  margin-top: 10px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n}\n\n.outcome_applied {\n  color: var(--curio-success-text);\n}\n\n.outcome_stale {\n  color: var(--curio-warning-text);\n}\n\n.error {\n  margin-top: 8px;\n  font-size: 0.76rem;\n  color: var(--curio-danger-text);\n}\n\n/* A package draft's justification for its new node types: the model's\n   reasoning, rendered verbatim above the draft's details. */\n.justification {\n  margin-top: 8px;\n  padding: 8px 10px;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  background: var(--curio-warning-bg);\n  border-left: 3px solid var(--curio-warning-text);\n  border-radius: 4px;\n  color: var(--curio-warning-text);\n}\n\n/* Secondary metadata / effect lines under the preview. */\n.meta {\n  margin-top: 6px;\n  font-size: 0.74rem;\n  color: var(--curio-text-secondary);\n}\n\n/* dev/59 (DEC-049.2) — the destructive Removes section: reviewed by name. */\n.removals {\n  margin-top: 8px;\n  padding: 8px 10px;\n  background: var(--curio-danger-bg);\n  border-left: 3px solid var(--curio-danger-text);\n  border-radius: 4px;\n}\n\n.removalsTitle {\n  font-size: 0.76rem;\n  font-weight: 700;\n  color: var(--curio-danger-strong);\n}\n\n.removalsList {\n  margin: 4px 0 0;\n  padding-left: 18px;\n  font-size: 0.74rem;\n  color: var(--curio-danger-strong);\n}\n\n/* dev/67-5 — the per-node plan review rows (Simulation Mode: create). */\n.planNodes {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.planNodeRow {\n  border: 1px solid var(--curio-border);\n  border-radius: 6px;\n  padding: 8px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.planNodeHead {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.planNodeTitle {\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.planNodeType {\n  color: var(--curio-text-secondary);\n  font-size: 0.75rem;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.planNodeCreated {\n  color: var(--curio-success-text);\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.planNodeExpects {\n  color: var(--curio-text-secondary);\n  font-size: 0.75rem;\n}\n\n/* dev/72: the compact icon-link riding a row's review chip — opens the node\n * agent's chat, where the content review and Solve trace live. */\n.reviewLink {\n  margin-left: 5px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 1px solid currentColor;\n  background: var(--curio-card-bg);\n  color: inherit;\n  font-size: 9px;\n  padding: 0;\n  cursor: pointer;\n  vertical-align: middle;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.reviewLink:hover,\n.reviewLink:focus-visible {\n  transform: scale(1.12);\n  outline: none;\n}\n\n.planGoalInput {\n  width: 100%;\n  box-sizing: border-box;\n  font: inherit;\n  font-size: 0.8rem;\n  padding: 6px 8px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 4px;\n  resize: vertical;\n}\n\n.planGoalInput:disabled {\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-secondary);\n}\n\n/* dev/67-7 — the validation verdict block. */\n.validation {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  font-size: 0.8rem;\n}\n\n.validationPass {\n  background: var(--curio-success-bg);\n  border: 1px solid var(--curio-success-bg);\n  color: var(--curio-success-text);\n}\n\n.validationFail {\n  background: var(--curio-danger-bg);\n  border: 1px solid var(--curio-danger-border);\n  color: var(--curio-danger-text);\n}\n\n.validationBadge {\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.validationDetails {\n  flex-basis: 100%;\n}\n\n.validationDetails pre {\n  margin: 6px 0 0;\n  max-height: 160px;\n  overflow: auto;\n  font-size: 0.72rem;\n  white-space: pre-wrap;\n}\n\n/* dev/67-8 — the connection review rows (Simulation Mode: connect). */\n.planEdges {\n  margin-top: 8px;\n  border: 1px solid var(--curio-border);\n  border-radius: 6px;\n  padding: 8px 10px;\n}\n\n.planEdgesHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 0.82rem;\n  margin-bottom: 6px;\n}\n\n.planEdgesList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.planEdgeRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  font-size: 0.8rem;\n}\n\n.planEdgeRow .apply {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.planEdgeNames {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 0.75rem;\n  min-width: 0;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.planEdgeRefused {\n  color: var(--curio-danger-text);\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n/* #662: a scenario the plan saves, in its color, with its nodes by name. */\n.planScenarioRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.8rem;\n}\n\n.planScenarioSwatch {\n  flex: 0 0 auto;\n  width: 10px;\n  height: 10px;\n  margin-top: 4px;\n  border-radius: 3px;\n  background: var(--scenario-color);\n}\n\n.planScenarioText {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.planScenarioName {\n  font-weight: 600;\n}\n\n/* dev/96: the rich draft sections — native disclosure, calm by default. */\n.draftSection {\n    margin: 8px 12px 0;\n    font-size: var(--curio-font-size-sm);\n    font-family: var(--curio-font-family);\n    color: var(--curio-text-secondary, var(--curio-text-secondary));\n}\n\n.draftSection summary {\n    cursor: pointer;\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.draftList {\n    margin: 4px 0 0;\n    padding-left: 18px;\n    overflow-wrap: anywhere;\n}\n\n.draftOverflow {\n    font-style: italic;\n}\n\n.findingBlock {\n    color: var(--curio-danger-strong, var(--curio-danger-text));\n    font-weight: 600;\n}\n\n.findingWarn {\n    color: var(--curio-warning-text);\n}\n\n.draftNodesRow {\n    margin: 8px 12px 0;\n    font-size: var(--curio-font-size-sm);\n    color: var(--curio-text-secondary, var(--curio-text-secondary));\n}\n\n/* dev/114 (DEC-072) — the Source block: how the runtime grounded what the\n   proposed code opens or fetches. Neutral surface; the verdict chip states\n   its status in text. */\n.sourceBlock {\n    margin-top: 8px;\n    padding: 8px 10px;\n    border-radius: 6px;\n    background: var(--curio-surface-muted);\n    border: 1px solid var(--curio-border);\n    font-size: 0.76rem;\n}\n\n.sourceTitle {\n    font-weight: 700;\n    color: var(--curio-text-primary);\n}\n\n.sourceList {\n    margin: 4px 0 0;\n    padding-left: 18px;\n    color: var(--curio-text-secondary);\n    overflow-wrap: anywhere;\n}\n\n/* dev/115 — the verification attempt trail (collapsed by default). */\n.attempts {\n    margin: 6px 0 0;\n    padding-left: 18px;\n    font-size: 0.74rem;\n}\n\n.attemptHead {\n    font-weight: 600;\n}\n\n.attemptDetail {\n    color: var(--curio-text-secondary);\n}\n\n.attemptError summary {\n    cursor: pointer;\n    color: var(--curio-danger-text);\n    overflow-wrap: anywhere;\n}\n\n.attemptEndpoint {\n    display: block;\n    color: var(--curio-text-secondary);\n    overflow-wrap: anywhere;\n}\n\n.attemptRemedy {\n    display: inline-block;\n    margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `c_yQ1hJrmzZg16wZJySr`,
	"header": `XaZ0DF3Mq1bQSg64e6rD`,
	"accentDot": `XlJ7yaqUzLvfe7CaJAWz`,
	"kind": `fXxjWqNp9g9kGJnSHcvA`,
	"preview": `ORmL_YmfCrNOshFxSj8i`,
	"actions": `iTw0KtmO9_ZeojNnthZC`,
	"apply": `wa77Q9ygBxX1MtJXF8pg`,
	"dismiss": `wfO2zuR9VuZRALhw5WxU`,
	"outcome": `FhIGkbyO3v_jkEKJErqf`,
	"outcome_applied": `GF8NPrU5M3FNo1e2TEpu`,
	"outcome_stale": `Ol2Z74RStwkH6W0_3tQr`,
	"error": `DLGHKA1GUq8QQQflI0vo`,
	"justification": `lEfUDGL_6wzgv6jMK5Ft`,
	"meta": `GUcTCeHwo2Stw9FmPJ6k`,
	"removals": `u3or3OY1hwgL66hrDZ71`,
	"removalsTitle": `QLjKHtm5uDcfxgHRXbzZ`,
	"removalsList": `jfrQu3R0XzS_5rj74rts`,
	"planNodes": `HQl2HrIB8Xls9YVFcw3g`,
	"planNodeRow": `Omoie3kvonUE5tcfMlJF`,
	"planNodeHead": `rDkdKv1L0K35odLTtiMu`,
	"planNodeTitle": `xXZJ_Y2r7O611uokmfPu`,
	"planNodeType": `glPOeqqK0wte1u0xJlyr`,
	"planNodeCreated": `zuPyxMaHxsOqWUJlWv5O`,
	"planNodeExpects": `S9FK68_Txx1Qm1XZVoX6`,
	"reviewLink": `bcMOCFRaCMac771vQ8kA`,
	"planGoalInput": `mWkBauPD23Qc7TBsxpuK`,
	"validation": `XTniMIjeUOinOVqpaKdq`,
	"validationPass": `dzpV1RYVi1BjoVKmci2T`,
	"validationFail": `GKH3APA9mpg2y1nfB2ss`,
	"validationBadge": `imFApHGhhaxGPmbzbgkU`,
	"validationDetails": `aWp14DI9dgOGuYy5MQGQ`,
	"planEdges": `DyiCofErvZ8mmAsbmuYN`,
	"planEdgesHead": `BSnuADPIzpGXSFO4cIbw`,
	"planEdgesList": `Nc2C5DlEQpzLzg_q8ncY`,
	"planEdgeRow": `tTs6pErgFjGhXqFBg0eV`,
	"planEdgeNames": `r7vavrXRuawOpe202eLg`,
	"planEdgeRefused": `T6xa3Dtmp_2GDnUZbpQU`,
	"planScenarioRow": `xucd8XxWdumB3Hyo64ho`,
	"planScenarioSwatch": `kQFiptb2EYlHi7nbxMSx`,
	"planScenarioText": `tDreBcNhIhUGlpiRpMVh`,
	"planScenarioName": `LjRRjl8UIFhP2C8JFsZ8`,
	"draftSection": `yGqSRkAPXCYCPMrCEizL`,
	"draftList": `iHi2YWRXRowBMRMaI91w`,
	"draftOverflow": `vWJUGFzrD79_khhpzBHv`,
	"findingBlock": `K1RHPRmIQ_2eN0mgKR4w`,
	"findingWarn": `_1a9SXJXDC1Qol5j8GUcw`,
	"draftNodesRow": `_7NYx1mcJw6vrTIDQQWr`,
	"sourceBlock": `E70nPb3aZdMoByfViSAQ`,
	"sourceTitle": `Xg2aEOrXrvZZwO0oJiNF`,
	"sourceList": `CWiiRGEBSQDOaJaBfhYC`,
	"attempts": `Sd2cXaKhxpkIUCboA_ii`,
	"attemptHead": `iGtqwGX0gbYNWcpOGkQO`,
	"attemptDetail": `aEHokL6SePrQF03aw4ei`,
	"attemptError": `HNPRhqpivrjSYoYhmFIT`,
	"attemptEndpoint": `URaiPGZxl2zYYwGP46wX`,
	"attemptRemedy": `X3shZyRyTw9CDKMoqG_m`
};
export default ___CSS_LOADER_EXPORT___;
